import CouponApi from '@apis/coupon/CouponApi';
import couponQueries from '@apis/queries/couponQueries';
import { GetCouponsParams } from '@models/coupon';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useAtomValue } from 'jotai';

import { couponSortsAtom } from '../../../atoms/couponAtoms';

function useMyCoupons() {
    const sort = useAtomValue(couponSortsAtom).MY;
    const params: Omit<GetCouponsParams, 'page'> = {
        size: 10,
        sorter: sort === 'closingSoon' ? 'ExpiresAtAsc' : 'IssuedAtDesc',
    };
    const queryInfo = useInfiniteQuery({
        queryKey: couponQueries.list(params).queryKey,
        queryFn: ({ pageParam }) => CouponApi.getMyCoupons({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        refetchOnMount: 'always',
        staleTime: 0,
        getNextPageParam,
    });
    const coupons = getFlattenPageResponse(queryInfo);
    const isEmpty = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        coupons,
        isEmpty,
    };
}

export default useMyCoupons;
